import { Pipe, PipeTransform } from '@angular/core';
import {LocalizationService} from '../services/localization.service';
import {I18nKey} from '../models/language.model';
import {Observable} from 'rxjs';

@Pipe({
  name: 'i18n',
  standalone: false
})
export class I18nPipe implements PipeTransform {
  
  constructor(private localizationService: LocalizationService) {
  }
  
  transform(key: I18nKey): Observable<string> {
    return this.localizationService.getTranslationByKeyAsync(key);
  }

}
